<div class="table-responsive margin-top-15 table-view">
  <h5 class="table-title">Action Tracker</h5>
  <button [disabled]="DisableExport"
    class="btn btn-primary primary-btn button-excel"
    style="margin-bottom: 10px"
    (click)="exportToExcel()"
  >
    <i class="fa fa-file-excel-o"></i>Export To Excel
  </button>
  <p-table
    [value]="ActionData"
    [scrollable]="false"
    scrollHeight="500px"
    dataKey="Id"
    editMode="row"
    id="ActionTableToExport"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 250px">Unit</th>
        <th class="center-table" style="width: 250px">Open</th>
        <th class="center-table" style="width: 150px">Done</th>
        <th class="center-table" style="width: 150px">Accepted</th>
        <th class="center-table" style="width: 150px">Closed</th>
        <th class="center-table" style="width: 150px">Passed Due Date</th>
        <th class="center-table" style="width: 150px">Actions</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-ActionData
      let-editing="editing"
      let-ri="rowIndex"
    >
      <tr [pEditableRow]="ActionData">
        <td style="width: 250px">
          {{ ActionData.category }}
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ActionData.Open"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetActionTrackerSelectedDetails(
                    ActionData.UnitId,
                    ActionData.category,
                    1
                  )
                "
                data-target="#AT"
              >
                {{ ActionData.Open }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ActionData.Done"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetActionTrackerSelectedDetails(
                    ActionData.UnitId,
                    ActionData.category,
                    2
                  )
                "
                data-target="#AT"
              >
                {{ ActionData.Done }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ActionData.Accepted"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetActionTrackerSelectedDetails(
                    ActionData.UnitId,
                    ActionData.category,
                    3
                  )
                "
                data-target="#AT"
              >
                {{ ActionData.Accepted }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ActionData.Closed"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetActionTrackerSelectedDetails(
                    ActionData.UnitId,
                    ActionData.category,
                    4
                  )
                "
                data-target="#AT"
              >
                {{ ActionData.Closed }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ActionData.PassedDueDate"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetActionTrackerSelectedDetails(
                    ActionData.UnitId,
                    ActionData.category,
                    5
                  )
                "
                data-target="#AT"
              >
                {{ ActionData.PassedDueDate }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table" *ngIf="ActionData.category != 'Total'">
          <button
            *ngIf="!editing"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(ActionData)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(ActionData)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(ActionData, ri)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
  class="modal fade PDModal"
  data-backdrop="static"
  style="opacity: 1 !important"
  id="AT"
  role="dialog"
>
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of ATData; let i = index">
            <li>
              <a (click)="Redirect(item.value, item.ID)">{{ item.Text }}</a>
            </li>
          </ng-container>
        </ol>
        <span *ngIf="ATData?.length < 1" style="color: red"
          >No Records Found..</span
        >
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>

<ara-performance-panel
  #child1
  hidden
  (getunits)="getData($event)"
></ara-performance-panel>
